/** Аплоадер */
export var getUploaderEndpoints = function () { return ({
    uploadAvatar: {
        invalidatesTags: ["getUsers"],
        query: function (data) {
            var formData = new FormData();
            formData.append("avatar", data.body.avatar);
            formData.append("fileId", data.body.fileId);
            return {
                url: "/api/v1/upload/avatar",
                method: "POST",
                body: formData,
            };
        },
    },
    uploadCover: {
        invalidatesTags: ["getPlaces"],
        query: function (data) {
            var formData = new FormData();
            // Добавляем массив id файлов
            for (var i = 0; i < data.body.fileIds.length; i++) {
                formData.append("fileIds", data.body.fileIds[i]);
            }
            // Добавляем все выбранные файлы
            for (var i = 0; i < data.body.cover.length; i++) {
                formData.append("cover", data.body.cover[i]);
            }
            return {
                url: "/api/v1/upload/cover",
                method: "POST",
                body: formData,
            };
        },
    },
}); };
